var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWormhole(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3251",
    "data-name": "Group 3251",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 649.403,
    height: 113.204,
    viewBox: "0 0 649.403 113.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1331",
    "data-name": "Rectangle 1331",
    width: 649.403,
    height: 113.204,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2614",
    "data-name": "Group 2614",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    d: "M182.294,30.01l-14.853,42a.96.96,0,0,1-.987.653h-1.127a1.035,1.035,0,0,1-1-.653l-11.136-29.46-11.118,29.46a1,1,0,0,1-.987.653h-1.146a.988.988,0,0,1-.986-.653L124.1,30.027c-.229-.651.018-1.057.653-1.057h4.6a.956.956,0,0,1,1,.653l10.589,31.8L151.707,32.3a1.019,1.019,0,0,1,1-.651h.969a1,1,0,0,1,.987.651L165.75,61.426l10.342-31.8a.956.956,0,0,1,1-.653h4.528c.653,0,.9.406.67,1.04",
    transform: "translate(28.417 6.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    d: "M232.2,50.585a21.919,21.919,0,1,1-43.836,0,21.919,21.919,0,1,1,43.836,0m-6.078,0c0-10.183-6.642-17.2-15.84-17.2s-15.84,7.013-15.84,17.2,6.642,17.2,15.84,17.2,15.84-7.013,15.84-17.2",
    transform: "translate(43.163 6.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M277.425,70.218a1.058,1.058,0,0,1-.934,1.744H272.35a.818.818,0,0,1-.67-.387L261.285,55.893H250.115V71.08a.9.9,0,0,1-.881.881H245.2a.9.9,0,0,1-.88-.881V29.851a.9.9,0,0,1,.88-.881h15.911c11.135,0,16.633,5.851,16.633,13.462,0,6.044-3.454,10.978-10.449,12.757ZM259.964,50.959c8.756,0,11.7-3.63,11.7-8.528,0-4.881-2.943-8.528-11.7-8.528h-9.849V50.959Z",
    transform: "translate(55.984 6.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M334.97,28.4h1.321a.833.833,0,0,1,.881.881V71.212a.833.833,0,0,1-.881.881h-4.034a.833.833,0,0,1-.881-.881V41.453l-16.3,23.592a.668.668,0,0,1-1.216,0l-16.3-23.592V71.212a.833.833,0,0,1-.881.881h-4.035a.833.833,0,0,1-.881-.881V29.278a.833.833,0,0,1,.881-.881h1.3a1.325,1.325,0,0,1,1.093.6l19.417,27.116L333.9,29a1.272,1.272,0,0,1,1.074-.6",
    transform: "translate(66.856 6.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M389.054,29.851V71.08a.9.9,0,0,1-.881.881h-4.034a.9.9,0,0,1-.881-.881V52.3H356.494V71.08a.9.9,0,0,1-.881.881h-4.035a.9.9,0,0,1-.881-.881V29.851a.9.9,0,0,1,.881-.881h4.035a.9.9,0,0,1,.881.881V47.365h26.763V29.851a.9.9,0,0,1,.881-.881h4.034a.9.9,0,0,1,.881.881",
    transform: "translate(80.36 6.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M446.026,50.585a21.919,21.919,0,1,1-43.836,0,21.919,21.919,0,1,1,43.836,0m-6.078,0c0-10.183-6.642-17.2-15.84-17.2s-15.84,7.013-15.84,17.2,6.642,17.2,15.84,17.2,15.84-7.013,15.84-17.2",
    transform: "translate(92.159 6.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M488.571,67.909V71.08a.833.833,0,0,1-.881.881H459.023a.9.9,0,0,1-.881-.881V29.851a.9.9,0,0,1,.881-.881h4.035a.9.9,0,0,1,.88.881V67.028h23.751a.833.833,0,0,1,.881.881",
    transform: "translate(104.98 6.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M534.438,67.909V71.08a.833.833,0,0,1-.881.881H502.6a.9.9,0,0,1-.881-.881V29.851a.9.9,0,0,1,.881-.881h30.253a.833.833,0,0,1,.881.881v3.171a.833.833,0,0,1-.881.881H507.516V47.365h22.518a.827.827,0,0,1,.88.863v3.19a.832.832,0,0,1-.88.88H507.516v14.73h26.041a.833.833,0,0,1,.881.881",
    transform: "translate(114.965 6.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M56.6,113.2a56.6,56.6,0,1,1,56.6-56.6,56.667,56.667,0,0,1-56.6,56.6m0-110.693A54.091,54.091,0,1,0,110.693,56.6,54.153,54.153,0,0,0,56.6,2.511",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M59.3,106.559A50.858,50.858,0,1,1,110.158,55.7,50.915,50.915,0,0,1,59.3,106.559m0-99.538A48.681,48.681,0,1,0,107.983,55.7,48.735,48.735,0,0,0,59.3,7.021",
    transform: "translate(1.935 1.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M62,99.911A45.112,45.112,0,1,1,107.111,54.8,45.161,45.161,0,0,1,62,99.911m0-88.383A43.271,43.271,0,1,0,105.27,54.8,43.319,43.319,0,0,0,62,11.528",
    transform: "translate(3.87 2.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M64.7,93.267A39.368,39.368,0,1,1,104.065,53.9,39.413,39.413,0,0,1,64.7,93.267m0-77.23A37.861,37.861,0,1,0,102.559,53.9,37.9,37.9,0,0,0,64.7,16.038",
    transform: "translate(5.804 3.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M67.4,86.621A33.623,33.623,0,1,1,101.02,53,33.661,33.661,0,0,1,67.4,86.621m0-66.074A32.451,32.451,0,1,0,99.848,53,32.487,32.487,0,0,0,67.4,20.548",
    transform: "translate(7.739 4.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M70.1,79.974A27.878,27.878,0,1,1,97.974,52.1,27.91,27.91,0,0,1,70.1,79.974m0-54.918A27.041,27.041,0,1,0,97.137,52.1,27.07,27.07,0,0,0,70.1,25.056",
    transform: "translate(9.674 5.549)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWormhole);
export default __webpack_public_path__ + "static/media/wormhole.05ad8596d2d996909816d60d9b3b3318.svg";
export { ForwardRef as ReactComponent };